module.exports = global.WebSocket || global.MozWebSocket;



/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/sockjs-client/lib/transport/browser/websocket.js
 ** module id = 219
 ** module chunks = 0
 **/